
document.addEventListener("click", e => {
  const path = e.composedPath();
  const selectorCheckout = `form[action="/checkout"] .xo-btn.xo-btn--dark, [name="checkout"], .upcart-checkout-button, .rebuy-cart__checkout-button, .button-checkout`;
  const target = path.find(el => {
    return el?.matches?.(selectorCheckout);
  });
  if ((e.target && e.target.closest(selectorCheckout)) || target) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
  }
}, 1);

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 1000);
    }
  });

  const labels = document.querySelectorAll('.xo-field-radio.xo-field-radio--boxed2');

    labels.forEach(label => {
        label.addEventListener('change', function() {
            setTimeout(() => {
                const productForm = document.querySelector('[bss-b2b-product-form="main"]');
            BSS_B2B?.observer?.productSubject?.notifyObserver?.(
                'VariantChange',
                'VariantSelectChange',
                { productForm }
            );
            }, 1000);
        });
    });
});
